export const PRICE_EXCLUDES_TAX_LABEL =
  'Belum termasuk pajak hotel 10% & service charge 10%';

export const toPreTaxPrice = (finalPrice) => Math.round(finalPrice / 1.21);

export const getFinalPriceBreakdown = (finalPrice) => {
  const basePrice = toPreTaxPrice(finalPrice);
  const serviceCharge = Math.round(basePrice * 0.10);
  const tax = Math.round((basePrice + serviceCharge) * 0.10);

  return { basePrice, serviceCharge, tax, total: finalPrice };
};
